import { faCheckCircle, faHome } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import styled from 'styled-components';
import LocationDropdown from './LocationDropdown';

class SavedLocations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false
    };
  }

  toggleDropdown() {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  }

  onLocationChange(event) {
    this.props.onChangeOutlet(event);
  }

  render() {
    let grid_layout = localStorage.getItem('grid_layout');
    const card_outline = this.props.locationSettings.card_outline_enable === 1 ? 'card-outline-color' : 'card-outline-color-hide';
    if (grid_layout === 'old') {
      return this.props.data
        ? this.props.data.map((item, index) => {
          const isEqual = this.props.selectedLocation
            ? `${this.props.selectedLocation.name}-${this.props.selectedLocation.latitude}-${this.props.selectedLocation.longitude}` ===
            `${item.name}-${item.latitude}-${item.longitude}`
            : false;
          return (
            <React.Fragment>
              <div
                className={`card flex-md-row card-color box-shadow h-md-250 p-3 m-2 ${card_outline} ${isEqual ? '' : 'bg-outlet no-border'
                  }`}
                onClick={this.onLocationChange.bind(this, item)}
              >
                <div className="row row-width">
                  <div className="col-lg-12 order-types d-flex" id="order_type_id">
                    {isEqual ? (
                      <div style={{ width: '4%' }}>

                        <button className="btn btn-link p-0 highlight-color">
                          {' '}
                          <FontAwesomeIcon icon={faCheckCircle} size={'lg'} />
                        </button>
                      </div>
                    ) : null}
                    <div className=" flex-1" id="order_time">
                      <div className="time-field">
                        <div className="f2">
                          <span className="ps-2 type-title card-font-color">
                            <FontAwesomeIcon icon={faHome} color='var(--card-font-color)' /> {item.name}
                          </span>
                          <br />
                          <small>
                            <span className="working-hour fw-normal card-font-color">{item.address}</span>
                          </small>
                        </div>
                        <LocationDropdown
                          item={item}
                          itemIndex={index}
                          onEdit={this.props.onEditLocation}
                          onDelete={this.props.onDeleteLocation}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        })
        : '';
    } else if (grid_layout !== 'old') {
      return this.props.data
        ? this.props.data.map((item, index) => {
          const isEqual = this.props.selectedLocation
            ? `${this.props.selectedLocation.name}-${this.props.selectedLocation.latitude}-${this.props.selectedLocation.longitude}` ===
            `${item.name}-${item.latitude}-${item.longitude}`
            : false;

          return (
            <StyledCard>
              <div
                className={`card card-custom flex-md-row box-shadow h-md-250 card-color p-3 ${card_outline} ${isEqual ? ' ' : 'bg-outlet no-border inactive-custom-card'
                  }`}
                onClick={this.onLocationChange.bind(this, item)}
              >
                <div className="row row-width">
                  <div className="col-lg-12 order-types d-flex" id="order_type_id">
                    {isEqual ? (
                      <button className="btn btn-link p-0 highlight-color">
                        {' '}
                        <FontAwesomeIcon icon={faCheckCircle} size={'lg'} />
                      </button>
                    ) : null}
                    <div className="flex-1" id="order_time">
                      <div className="time-field">
                        <div className="f2">
                          <span className="type-title card-font-color">
                            <FontAwesomeIcon icon={faHome} color='var(--card-font-color)' /> {item.name}
                          </span>
                          <br />
                          <small>
                            <span className="working-hour card-font-color d-inline-block fw-light">{item.address}</span>
                          </small>
                        </div>
                        <LocationDropdown
                          item={item}
                          itemIndex={index}
                          onEdit={this.props.onEditLocation}
                          onDelete={this.props.onDeleteLocation}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </StyledCard>
          );
        })
        : '';
    }
  }
}
const StyledCard = styled.div`
  .card-custom-location {
    padding: 30px 20px !important;
    margin-top: 20px !important;
    margin-bottom: 20px !important;
    cursor: pointer;

    .order-types {
      padding-right: 5px !important;
      column-gap: 5px;

      .ps-3 {
        padding-left: 0 !important;
        padding-right: 0 !important;

        .time-field {
          margin: 0 !important;

          .text-bold {
            .type-title {
              font-size: 16px !important;
               
              font-weight: 500 !important;
              line-height: 20px !important;
              color: #2e2e2e;
              padding-left: 0 !important;

              svg {
                margin-right: 5px;
              }
            }
            margin-right: 5px;
          }

          small {
            .working-hour {
              font-size: 14px !important;
               
              font-weight: 300 !important;
              line-height: 18px !important;
              color: #2e2e2e;
              padding-left: 24px !important;
            }
          }

          .f3 {
            .ps-2 {
            }
          }
        }
      }
    }
  }
  .active-custom-card {
    border: unset !important;
    border-radius: 10px !important;
    background: #ffffff !important;
    box-shadow: 0 3px 20px rgb(0 0 0 / 6%) !important;
  }
  .inactive-custom-card {
    box-shadow: unset !important;
  }
`;
export default SavedLocations;
